// extracted by mini-css-extract-plugin
export var cell = "_5h-4";
export var headerCell = "_5h-2";
export var rowHeader = "_5h-3";
export var table = "_5h-1";
export var tableContainer = "_5h-0";